import { DirectDealCategory, DirectDealStatus } from '@services/directDeals.types';
import {
	DirectDealBasket,
	DirectDealBasketsResponse,
	DirectDealBasketsSummary,
	DirectDealOverview,
	DirectDealsKpiSummary,
	ReportDirectDealDetail,
	ReportDirectDealSummary,
} from '@services/marketBasketReports.types'


export const directDealOverview: DirectDealOverview = {
	recommendedTotal: 120,
	recommendedAccepted: 92,
	declineTotal: 80,
	declineRejected: 9,
}

export const directDealReportBasketsSummary: DirectDealsKpiSummary = {
	recommendPct: 0.8,
	reviewPct: 0.5,
	declinePct: 0.2,
}

//
// import { BasketSummary, DirectDealEntry, DirectDealsKpiSummary } from './directDeals.types'
export const directDealReportKpis: DirectDealsKpiSummary = {
	recommendPct: 0.8,
	reviewPct: 0.5,
	declinePct: 0.2,
}

export const directDealReportBaskets: ReportDirectDealSummary[] = [
	{
		id: '1',
		name: 'Mos Eisley Cantina (PA)',
		caseNumber: 'SF-4569001',
		recommend: { count: 75, total: 75 },
		review: { count: 50, total: 50 },
		decline: { count: 25, total: 25 },
	},
	{
		id: '2',
		name: 'Docking Bay 94 (NY)',
		caseNumber: 'SF-4569002',
		recommend: { count: 60, total: 75 },
		review: { count: 25, total: 50 },
		decline: { count: 5, total: 25 },
	},
	{
		id: '3',
		name: 'Tosche Station (CA)',
		caseNumber: 'SF-4569003',
		recommend: { count: 60, total: 75 },
		review: { count: 25, total: 50 },
		decline: { count: 5, total: 25 },
	},
	{
		id: '4',
		name: "Jabba's Palace (TX)",
		caseNumber: 'SF-4569004',
		recommend: { count: 60, total: 75 },
		review: { count: 25, total: 50 },
		decline: { count: 5, total: 25 },
	},
	{
		id: '5',
		name: 'Cantina Band HQ (CO)',
		caseNumber: 'SF-4569005',
		recommend: { count: 60, total: 75 },
		review: { count: 25, total: 50 },
		decline: { count: 5, total: 25 },
	},
	{
		id: '6',
		name: 'Cloud City (FL)',
		caseNumber: 'SF-4569006',
		recommend: { count: 60, total: 75 },
		review: { count: 25, total: 50 },
		decline: { count: 5, total: 25 },
	},
]

export const directDealReportBasketList: DirectDealBasket[] = [
	{
		marketBasketId: 2456,
		displayName: 'Cloud City (FL)',
		salesforceCaseId: null,
		createdAt: '2026-06-22T18:58:32.7184Z',
		recommendedTotal: 2,
		recommendedAccepted: 2,
		declineTotal: 6,
		declineRejected: 6,
	},
	{
		marketBasketId: 2455,
		displayName: 'Mos Eisley Cantina (PA)',
		salesforceCaseId: null,
		createdAt: '2026-06-22T18:58:29.449354Z',
		recommendedTotal: 3,
		recommendedAccepted: 2,
		declineTotal: 4,
		declineRejected: 2,
	},
	{
		marketBasketId: 2432,
		displayName: 'Tatooine Outpost (NV)',
		salesforceCaseId: null,
		createdAt: '2026-06-16T18:41:27.23915Z',
		recommendedTotal: 0,
		recommendedAccepted: 0,
		declineTotal: 3,
		declineRejected: 0,
	},
	{
		marketBasketId: 2425,
		displayName: 'Tosche Station (CA)',
		salesforceCaseId: null,
		createdAt: '2026-06-12T14:56:38.164002Z',
		recommendedTotal: 0,
		recommendedAccepted: 0,
		declineTotal: 3,
		declineRejected: 0,
	},
]

export const directDealReportBasketListSummary: DirectDealBasketsSummary = {
	totalBaskets: 4,
	recommendedTotal: 5,
	recommendedAccepted: 4,
	declineTotal: 16,
	declineRejected: 8,
}

export const directDealBasketsResponse: DirectDealBasketsResponse = {
	data: directDealReportBasketList,
	pagination: {
		page: 1,
		pageSize: 100,
		total: 4,
		totalPages: 1,
	},
	summary: directDealReportBasketListSummary,
}

export const directDealReportDealsList: ReportDirectDealDetail[] = [
	{
		id: '1',
		manufacturerName: 'Manufacturer A',
		status: DirectDealStatus.ACCEPTED,
		category: DirectDealCategory.RECOMMEND,
		coverage: 100,
		stocking: 95,
		annualPriceSavings: 1267,
		annualRebateSavings: 1267,
		annualTotalSavings: 3267,
		exactCoverage: 99.4,
		exactAnnualPriceSavings: 1259.83,
		exactAnnualRebateSavings: 1261.12,
		exactAnnualTotalSavings: 3258.95,
	},
	{
		id: '2',
		manufacturerName: 'Manufacturer B',
		status: DirectDealStatus.REJECTED,
		category: DirectDealCategory.DECLINE,
		coverage: 32,
		stocking: 40,
		annualPriceSavings: -750,
		annualRebateSavings: 125,
		annualTotalSavings: -625,
		exactCoverage: 31.7,
		exactAnnualPriceSavings: -752.4,
		exactAnnualRebateSavings: 124.18,
		exactAnnualTotalSavings: -628.22,
	},
	{
		id: '3',
		manufacturerName: 'Manufacturer C',
		status: DirectDealStatus.ACCEPTED,
		category: DirectDealCategory.RECOMMEND,
		coverage: 100,
		stocking: 95,
		annualPriceSavings: 1267,
		annualRebateSavings: 1267,
		annualTotalSavings: 3267,
		exactCoverage: 99.8,
		exactAnnualPriceSavings: 1264.21,
		exactAnnualRebateSavings: 1265.77,
		exactAnnualTotalSavings: 3263.98,
	},
	{
		id: '4',
		manufacturerName: 'Manufacturer D',
		status: DirectDealStatus.ACCEPTED,
		category: DirectDealCategory.RECOMMEND,
		coverage: 75,
		stocking: 80,
		annualPriceSavings: 500,
		annualRebateSavings: 300,
		annualTotalSavings: 800,
		exactCoverage: 74.6,
		exactAnnualPriceSavings: 497.55,
		exactAnnualRebateSavings: 298.9,
		exactAnnualTotalSavings: 796.45,
	},
	{
		id: '5',
		manufacturerName: 'Manufacturer E',
		status: DirectDealStatus.ACCEPTED,
		category: DirectDealCategory.RECOMMEND,
		coverage: 100,
		stocking: 95,
		annualPriceSavings: 1267,
		annualRebateSavings: 1267,
		annualTotalSavings: 3267,
		exactCoverage: 99.1,
		exactAnnualPriceSavings: 1258.4,
		exactAnnualRebateSavings: 1260.05,
		exactAnnualTotalSavings: 3256.45,
	},
	{
		id: '6',
		manufacturerName: 'Manufacturer F',
		status: DirectDealStatus.REJECTED,
		category: DirectDealCategory.DECLINE,
		coverage: 100,
		stocking: 95,
		annualPriceSavings: 1267,
		annualRebateSavings: 1267,
		annualTotalSavings: 3267,
		exactCoverage: 98.7,
		exactAnnualPriceSavings: 1255.6,
		exactAnnualRebateSavings: 1257.33,
		exactAnnualTotalSavings: 3252.93,
	},
]
